export const commonDoubleListBoxLeanStyle = ({ palette = {} }) => ({
  '& .doubleListBoxLean.layout-columns': {
    '& .layout-columns-container': {
      '& .layout-columns-element': {
        '& .panel-form': {
          '& .panel-body': {
            '& .dlb-source-container, & .dlb-selected-container': {
              '& .dlb-source.dlb-source-list, & .dlb-selected.dlb-selected-list': {
                outline: 'none',

                '&:empty:focus': {
                  outline: `1px solid ${palette.neutralSecondary}`,
                  outlineOffset: -1,
                  // border: `1px solid ${palette.neutralSecondary}`,
                },

                '& .dlbItem': {
                  '&:hover': {
                    backgroundColor: palette.neutralLighter,
                  },

                  '&.k-state-focused': {
                    outline: `1px solid ${palette.neutralSecondary}`,
                    outlineOffset: -1,
                    // border: `1px solid ${palette.neutralSecondary}`,
                  },

                  '&.k-state-selected, &.selected': {
                    backgroundColor: palette.neutralLight,
                  },
                },
              },
            },
          },
        },
      },
    },
  },
});
